export enum SweetAlertEnums {
    success = 0,
    error = 1,
    confirm = 2,
    info = 3,
    clone = 4
}

export enum SweetAlertSuccessEnum {
    add = 0,
    update = 1,
    delete = 2
}